module.exports = __webpack_public_path__ + "img/menu_mens_dermapen.81d3f2ef.png";